import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-new-website-welcome',
  imports: [],
  templateUrl: './new-website-welcome.component.html',
  styleUrl: './new-website-welcome.component.scss'
})
export class NewWebsiteWelcomeComponent {

  #router = inject(Router);
  #activeModal = inject(NgbActiveModal);

  goToShop() {
    this.#router.navigate(['/shop']);
    this.#activeModal.close();
  }
}
